import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Member } from 'src/app/models/member.model';
import { TeamService } from 'src/app/services/team.service';

@Component({
  selector: 'app-teamlid',
  templateUrl: './teamlid.component.html',
  styleUrls: ['./teamlid.component.sass']
})
export class TeamlidComponent implements OnInit {

  memberId: any;
  member: any;

  constructor(private activatedRoute: ActivatedRoute, private teamService:TeamService) { }

  ngOnInit(): void {

    // Check query params
    let params = this.activatedRoute.snapshot.queryParams;

    if(!params) return;

    this.memberId = params["teamlid"];

    this.teamService.getTeamlid(this.memberId).subscribe(data => {
        this.member = this.teamService.populateTeamlid(data.data[0]);
    });
  }

}
